import Konva from 'konva';

export type MouseKonvaHandler = (
  event: Konva.KonvaEventObject<MouseEvent>
) => void;

export function asTouchKonvaHandler(
  handler?: MouseKonvaHandler
): ((event: Konva.KonvaEventObject<TouchEvent>) => void) | undefined {
  if (!handler) {
    return undefined;
  }

  return (event: Konva.KonvaEventObject<TouchEvent>) => {
    handler(event as unknown as Konva.KonvaEventObject<MouseEvent>);
  };
}
